import { gql } from "@apollo/client";
import { API } from "api/API";
import axios, { AxiosProgressEvent } from "axios";
const APIInstance = new API();

export const insertIssue = gql`
    mutation insertIssue($issue: issue_insert_input!) {
        insert_issue_one(object: $issue) {
            issue_id
            title
            description
            due_date
            status_id
            priority_id
            owner_id
            created_at
            updated_at
            deleted_at
            mill_id
            issue_key_performance_indicators {
                key_performance_indicator_id
                issue_id
            }
            issue_key_success_factor_indicators {
                key_success_factor_indicator_id
                issue_id
            }
        }
    }
`;

export const insertObservationIssue = gql`
    mutation insertObservationIssue($observationIssue: [issue_observation_insert_input!]!) {
        insert_issue_observation(objects: $observationIssue) {
            returning {
                issue_observation_id
            }
        }
    }
`;

export const getIssuesCount = gql`
    query getIssuesCount($where: issue_bool_exp) {
        issue_aggregate(where: $where) {
            aggregate {
                count
            }
        }
    }
`;

export const getIssues = gql`
    query getIssues($limit: Int!, $offset: Int!, $order_by: [issue_order_by!], $where: issue_bool_exp) {
        issue(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
            issue_id
            title
            created_by
            description
            due_date
            meeting_type_id
            status {
                status_id
                name
                default_status_translations {
                    status_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
            priority {
                priority_id
                name
                default_priority_translations {
                    priority_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
            owner {
                user_id
                first_name
                last_name
                media {
                    media_id
                    media_url
                    media_type
                }
            }
            created_at
            updated_at
            deleted_at
            mill_id
            action_plans {
                action_plan_id
                description
                due_date
                status {
                    status_id
                    name
                    default_status_translations {
                        status_id
                        language {
                            language_id
                            name
                            code
                        }
                        translated_name
                    }
                }
                priority {
                    priority_id
                    name
                    default_priority_translations {
                        priority_id
                        language {
                            language_id
                            name
                            code
                        }
                        translated_name
                    }
                }
                submitted_by {
                    user_id
                    first_name
                    last_name
                    media {
                        media_id
                        media_url
                        media_type
                    }
                }
                assignee {
                    user_id
                    first_name
                    last_name
                    media {
                        media_id
                        media_url
                        media_type
                    }
                }
            }
            issue_observations {
                issue_observation_id
                description
            }
            issue_media(where: { media: { is_enabled: { _eq: true } }, deleted_at: { _is_null: true } }) {
                issue_media_id
                issue_id
                media {
                    name
                    media_id
                    media_type
                    media_url
                    is_enabled
                }
            }
        }
    }
`;

export const getIssueHistoricChangesLog = gql`
    query getIssueHistoricChangesLog($id: Int) {
        issue_history_log(where: { issue_id: { _eq: $id } }, order_by: { changed_at: desc }) {
            history_id
            field_name
            new_value
            old_value
            changed_at
            change_type
            user {
                first_name
                last_name
                media {
                    media_url
                }
            }
            action_plan_id
        }
    }
`;

export const getIssue = gql`
    query getIssue($issue_id: Int!) {
        issue(where: { issue_id: { _eq: $issue_id } }) {
            issue_id
            created_by
            title
            description
            due_date
            meeting_type_id
            issue_key_success_factor_indicators {
                key_success_factor_indicator_id
            }
            status {
                status_id
                name
                default_status_translations {
                    status_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
            priority {
                priority_id
                name
                default_priority_translations {
                    priority_id
                    language {
                        language_id
                        name
                        code
                    }
                    translated_name
                }
            }
            owner {
                user_id
                first_name
                last_name
                media {
                    media_id
                    media_url
                    media_type
                }
            }
            created_at
            incident_date
            updated_at
            deleted_at
            mill_id
            action_plans {
                action_plan_id
                description
                due_date
                status {
                    status_id
                    name
                    default_status_translations {
                        status_id
                        language {
                            language_id
                            name
                            code
                        }
                        translated_name
                    }
                }
                priority {
                    priority_id
                    name
                    default_priority_translations {
                        priority_id
                        language {
                            language_id
                            name
                            code
                        }
                        translated_name
                    }
                }
                submitted_by {
                    user_id
                    first_name
                    last_name
                    media {
                        media_id
                        media_url
                        media_type
                    }
                }
                assignee {
                    user_id
                    first_name
                    last_name
                    media {
                        media_id
                        media_url
                        media_type
                    }
                }
            }
            issue_observations(order_by: { created_at: desc }) {
                issue_observation_id
                description
                date
                created_at
                user {
                    user_id
                    first_name
                    last_name
                    media {
                        media_id
                        media_url
                        media_type
                    }
                }
            }
            issue_media(where: { media: { is_enabled: { _eq: true } }, deleted_at: { _is_null: true } }) {
                issue_media_id
                issue_id
                media {
                    name
                    media_id
                    media_type
                    media_url
                    is_enabled
                }
            }
        }
    }
`;

export const getKeySuccessFactors = gql`
    query getKeySuccessFactors {
        key_success_factors {
            corporate_id
            name
            key_success_factors_id
        }
    }
`;

export const getKeyPerformanceIndicators = gql`
    query getPerformanceIndicators {
        key_performance_indicators {
            corporate_id
            name
            key_performance_indicators_id
        }
    }
`;

export const uploadIssueFiles = async (
    issueId: number,
    userImageFormData: FormData,
    onUploadProgress: (progressEvent: AxiosProgressEvent) => void,
): Promise<{ publicUrl: string } | unknown> => {
    try {
        const url = `${APIInstance.api_root}/upload/issue-media/${issueId}`;
        const response = await axios.put<{ publicUrl: string }>(url, userImageFormData, { onUploadProgress });

        return response;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const updateIssue = gql`
    mutation updateIssue($issueId: Int!, $changes: issue_set_input!) {
        update_issue(where: { issue_id: { _eq: $issueId } }, _set: $changes) {
            affected_rows
            returning {
                issue_id
            }
        }
    }
`;

export const updateIssueWithKsf = gql`
    mutation updateIssueWithKsf(
        $issueId: Int!
        $changes: issue_set_input!
        $updateIndicator: Boolean!
        $indicatorInsertChanges: [issue_key_success_factor_indicator_insert_input!]!
        $indicatorUpdateChanges: issue_key_success_factor_indicator_set_input!
        $insertIndicator: Boolean!
    ) {
        update_issue(where: { issue_id: { _eq: $issueId } }, _set: $changes) {
            affected_rows
            returning {
                issue_id
            }
        }
        update_issue_key_success_factor_indicator(
            where: { issue_id: { _eq: $issueId } }
            _set: $indicatorUpdateChanges
        ) @include(if: $updateIndicator) {
            affected_rows
            returning {
                issue_key_success_factor_indicator_id
            }
        }
        insert_issue_key_success_factor_indicator(objects: $indicatorInsertChanges) @include(if: $insertIndicator) {
            affected_rows
            returning {
                issue_key_success_factor_indicator_id
            }
        }
    }
`;

export const updateIssueMedia = gql`
    mutation updateIssueMedia($issueMediaId: Int!, $changes: issue_media_set_input!) {
        update_issue_media(where: { issue_media_id: { _eq: $issueMediaId } }, _set: $changes) {
            affected_rows
            returning {
                issue_media_id
            }
        }
    }
`;
